import { AbstractCockpitError } from '@shared/common/error/domain/error/abstract-cockpit.error';

export class UnknownError extends AbstractCockpitError {
  public constructor(userMessage: string, code?: string, diagnosticMessage = userMessage, cause?: unknown) {
    super(diagnosticMessage, code, userMessage, cause === undefined ? undefined : { cause });
    this.name = 'UnknownCockpitApiError';
  }
}
